import { SxProps, Theme } from "@mui/material";

export const overviewMetricsGridStyle: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "1fr 1.2fr" },
  gap: 1.25,
};

export const overviewCardStyle: SxProps<Theme> = (theme) => ({
  borderRadius: "14px",
  border: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
  backgroundColor: theme.palette.mode === "dark" ? "#181E2D" : "#FFFFFF",
  p: { xs: 1.2, md: 1.4 },
  minHeight: { xs: "auto", md: 200 },
  display: "flex",
  flexDirection: "column",
});

export const overviewCardTitleStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 800,
  color: "text.primary",
  mb: 1,
};

export const completionBodyStyle: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
};

export const completionRingWrapStyle: SxProps<Theme> = {
  position: "relative",
  width: 132,
  height: 132,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const completionRingCenterStyle: SxProps<Theme> = {
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
};

export const completionPercentStyle: SxProps<Theme> = {
  fontSize: "28px",
  fontWeight: 800,
  color: "#0EA5E9",
  lineHeight: 1,
};

export const completionLabelStyle: SxProps<Theme> = {
  fontSize: "12px",
  color: "text.secondary",
  mt: 0.25,
};

export const completionFootnoteStyle: SxProps<Theme> = {
  fontSize: "12px",
  color: "text.secondary",
};

export const teamPerformanceBodyStyle: SxProps<Theme> = {
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr auto 1fr",
  alignItems: "center",
};

export const teamMetricColumnStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.25,
  px: { xs: 0.5, md: 1 },
};

export const teamMetricTextColumnStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 0.25,
};

export const teamMetricDividerStyle: SxProps<Theme> = {
  width: "1px",
  height: 72,
  alignSelf: "center",
  justifySelf: "center",
  backgroundColor: "rgba(148,163,184,0.35)",
};

export const teamMetricIconWrapStyle: SxProps<Theme> = {
  width: 40,
  height: 40,
  flexShrink: 0,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(14,165,233,0.12)",
  color: "#0EA5E9",
};

export const teamMetricLabelStyle: SxProps<Theme> = {
  fontSize: "12px",
  color: "text.secondary",
};

export const teamMetricValueStyle: SxProps<Theme> = {
  fontSize: "24px",
  fontWeight: 800,
  color: "text.primary",
  lineHeight: 1.1,
  whiteSpace: "nowrap",
};

export const teamMetricSubLabelStyle: SxProps<Theme> = {
  fontSize: "11px",
  color: "text.secondary",
};
